export default {
  name: "tag-card",
  components: {},
  props: ["typeOfTransaction", "data"],
  data() {
    return {
      dialog: false
    };
  },
  computed: {},
  mounted() {},
  methods: {
    handleDialog() {
      this.$emit("confirmWarning", false);
      this.dialog = true;
    }
  }
};
